import React, { useEffect } from 'react'
import styled from 'styled-components'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import * as Markdown from 'react-markdown'
import colors from '../styles/colors'
import Button from './atoms/Button'
import Usa from '../assets/icons/usa'
import Hardhat from '../assets/icons/hard-hat'
import Boxusd from '../assets/icons/boxusd'
import HeroRatingStars from './hero-rating-stars'
import Slider from 'react-slick'
import { ChevronLeft, ChevronRight } from 'react-feather'
import { motion } from "framer-motion";

const SliderContainer = styled.div`
  &:hover {
    .PrevNextArrowsContainer {
      opacity: 1 !important;
    }
  }
  .PrevNextArrowsContainer {
    opacity: 0.1;
    background-color: rgba(204, 204, 204, 0.4);
    &:hover {
      background-color: rgba(204, 204, 204, 0.9);
    }
  }
  &.server-rendered {
    .slick-track {
      left: 0% !important;
    }
  }
`
const PrevNextArrowsContainer = styled.div`
  position: absolute;
  z-index: 1;
  @media (max-width: 767px) {
    top: calc(50% - 15px);
    height: 30px;
    width: 30px;
    padding: 5px;
  }
  top: calc(50% - 25px);
  height: 50px;
  width: 50px;

  transition: 0.2s ease all;
  color: #333;
  border-radius: 50%;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;
  justify-content: center;
  &.carousel-icon-right {
    right: 18px;
  }
  &.carousel-icon-left {
    left: 18px;
  }
`


const NextArrow = (props) => {
  const { onClick } = props

  //auto scroll
  //setInterval(() => onClick(), 10000)

  return (
    <PrevNextArrowsContainer
      className="icon-container carousel-icon-left PrevNextArrowsContainer"
      onClick={onClick}
    >
      <ChevronLeft size={26} />
    </PrevNextArrowsContainer>
  )
}

const PrevArrow = (props) => {
  const { onClick } = props
  return (
    <PrevNextArrowsContainer
      className="icon-container carousel-icon-right PrevNextArrowsContainer"
      onClick={onClick}
    >
      <ChevronRight size={26} />
    </PrevNextArrowsContainer>
  )
}

const settings = {
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 7000,
  pauseOnHover: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  cssEase: 'linear',
  className: 'disable-interaction-on-non-active relative',
  nextArrow: <PrevArrow />,
  prevArrow: <NextArrow />,
}

const HeroContent = ({
  heroTitle,
  heroImage,
  heroVideo,
  description,
  primaryActionBtnLabel,
  primaryActionBtnLink,
  style,
  alt,
  preloadImage,
  hideImage,
}) => (

  <div className='sm:px-4 md:px-6  max-w-8xl mx-auto '>
    <section className="bg-white overflow-hidden relative sm:rounded-2xl" style={{ minHeight: '400px' }}>
      {/* <div className='Block-background HeroImageBlock-background u-bgColor--transparentOrange absolute right-0 top-0 bottom-20 bg-brand-50' style={{ zIndex: 0, width: '60%' }} /> */}

      {heroVideo && heroVideo.file && heroVideo.file.url ? (
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-0 left-0 w-full max-w-none h-full object-cover"
          style={{ position: 'absolute', objectPosition: 'center' }}
        >
          <source src={heroVideo.file.url} type={heroVideo.file.contentType || 'video/mp4'} />
        </video>
      ) : (
        <GatsbyImage
          image={getImage(heroImage)}
          alt={alt}
          loading={preloadImage}
          className="absolute top-0 left-0 w-full max-w-none h-full absolute-important "
          style={{ objectPosition: 'center' }}
        />
      )}
      <div className='absolute  top-0 left-0 w-full h-full opacity-50 bg-gradient-to-r from-black to-transparent' />

      <div className='absolute  top-0 left-0 w-full h-full opacity-25 bg-gradient-to-r from-brand-500 to-transparent' />
      <div className='max-w-7xl flex flex-wrap md:flex-nowrap items-center items-stretch		mx-auto heroImageBlock-home-container z-1' >

        <motion.div className='w-full md:w-1/2  px-6 md:px-8 py-12 md:py-24 shrink-0 z-1 relative  	'

          initial={{ opacity: 0, y: 5 }}
          whileInView={{ opacity: 1, y: 0, transition: { duration: .45 }, }}

          viewport={{ once: true }}>

          <span className='hidden text-accent-400 mb-2 block font-semibold md:text-lg'>Grime Busters</span>
          <h1 className='font-display font-extrabold text-3xl sm:text-4xl md:text-5xl text-white'>{heroTitle}</h1>
          <p className=' mb-4 pt-4 text-base md:text-lg text-white md:leading-7'>

            {description && description.description && (
              <Markdown
                className="feature-extended-image has-animation"
                children={description.description}
              />
            )}

          </p>


          <motion.div><Button color='accent' to='/services/'>Learn More</Button></motion.div>
          <HeroRatingStars theme="light" classes="text-white font-display font-medium   mx-auto" />
        </motion.div>


      </div>
    </section>
  </div>
)

const HeroArea = ({ heroContent }) => {
  // Debug logging
  console.log('HeroArea heroContent:', heroContent)
  if (heroContent.heroVideo) {
    console.log('heroVideo found:', heroContent.heroVideo)
  } else {
    console.log('No heroVideo in heroContent')
  }

  // Always use single hero area, no carousel
  // heroVideo is now part of heroContent object
  return <HeroContent {...heroContent} preloadImage />
}

export default HeroArea
